import moment from 'moment';

export default class WageAdvanceHelper {
  constructor() {
    'ngInject';
  }

  format(wagesAdvance) {
    return wagesAdvance
      .map(this.wageAdvanceCanBeCancelled)
      .sort(this.sortWagesAdvance);
  }

  sortWagesAdvance(wagesAdvanceA, wagesAdvanceB) {
    const a = new Date(wagesAdvanceA.requestDate);
    const b = new Date(wagesAdvanceB.requestDate);

    if (a > b) {
      return -1;
    }

    if (a < b) {
      return 1;
    }

    return 0;
  }

  wageAdvanceCanBeCancelled(wageAdvance) {
    const today = moment().format('YYYY-MM-DD');
    const requestDay = wageAdvance.requestDate;
    wageAdvance.canBeCancelled = (requestDay === today);
    return wageAdvance;
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvance.helper.js